// extracted by mini-css-extract-plugin
export default {"header":"PQRsMessage_header__I8WV6","pqrsType":"PQRsMessage_pqrsType__lhn10","description":"PQRsMessage_description__hGDRX"};